export default function SuccessIcon({
  size = 'w-[24px] h-[25px]',
  color = '#05603A',
}) {
  return (
    <svg
      className={size}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 11.8772V12.7972C21.9988 14.9536 21.3005 17.0519 20.0093 18.7791C18.7182 20.5062 16.9033 21.7697 14.8354 22.3811C12.7674 22.9925 10.5573 22.9191 8.53447 22.1718C6.51168 21.4245 4.78465 20.0433 3.61096 18.2343C2.43727 16.4253 1.87979 14.2853 2.02168 12.1335C2.16356 9.98179 2.99721 7.93355 4.39828 6.2943C5.79935 4.65505 7.69279 3.51261 9.79619 3.03737C11.8996 2.56214 14.1003 2.77956 16.07 3.65723"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 4.79736L12 14.8074L9 11.8074"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
